import React, {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { MyAnalytics, PageTopButton } from '../atoms';
import { Footer } from '../components';
import {getUser, getDayReport, setLoginState, clearState, getSleepToday, saveSleepRecord} from "../store/actions";
import HeaderTitle from "../atoms/HeaderTitle";
import {Link} from "react-router-dom";
import LoginFilter from "../atoms/LoginFilter";


const TopPage = props => {
  const dispatch = useDispatch();

  const { arg1 } = useParams();

  const navigate = useNavigate();

  const [dayReport, setDayReport] = useState(null);
  const [targetDate, setTargetDate] = useState(null);
  const [sleepInfo, setSleepInfo] = useState(null);

  // 睡眠時間編集用state
  const [isEditingSleep, setIsEditingSleep] = useState(false);
  const [editBedtime, setEditBedtime] = useState('');
  const [editWakeupTime, setEditWakeupTime] = useState('');
  const [savingSleep, setSavingSleep] = useState(false);

  
  const loadDayReport = async (targetDate) => {
 
    const response = await dispatch(getDayReport(targetDate))
    .then(res => {
      return res;
    }).catch(err => {

      // history.push("/login")
    });


    return response
  }
  
  const moveAnotherDate = async (argTargetDate) => {

    const res = await loadDayReport(argTargetDate);
    setDayReport(res)

    // 睡眠情報も該当日付で更新
    const sleepRes = await dispatch(getSleepToday(argTargetDate));
    setSleepInfo(sleepRes);

    // 日付変更時は編集モードを解除
    setIsEditingSleep(false);
  }

  // 睡眠時間編集モード開始
  const startEditSleep = () => {
    setEditBedtime(sleepInfo?.yesterday_bedtime || '');
    setEditWakeupTime(sleepInfo?.today_wakeup_time || '');
    setIsEditingSleep(true);
  };

  // 睡眠時間編集キャンセル
  const cancelEditSleep = () => {
    setIsEditingSleep(false);
    setEditBedtime('');
    setEditWakeupTime('');
  };

  // 睡眠時間保存
  const handleSaveSleep = async () => {
    setSavingSleep(true);
    try {
      // 前日の就寝時刻を保存
      if (sleepInfo?.yesterday_date) {
        await dispatch(saveSleepRecord({
          record_date: sleepInfo.yesterday_date,
          bedtime: editBedtime || null,
        }));
      }
      // 当日の起床時刻を保存
      if (sleepInfo?.today_date) {
        await dispatch(saveSleepRecord({
          record_date: sleepInfo.today_date,
          wakeup_time: editWakeupTime || null,
        }));
      }
      // 保存後に睡眠情報を再取得
      const currentDate = targetDate || new Date().toISOString().split('T')[0];
      const sleepRes = await dispatch(getSleepToday(currentDate));
      setSleepInfo(sleepRes);
      setIsEditingSleep(false);
    } catch (err) {
      console.error('Failed to save sleep record:', err);
    }
    setSavingSleep(false);
  };

  useEffect(() => {

    // useEffectで非同期関数を呼び
    (async () => {

      /*
       * 初期値をセット
       */

      const hiduke = new Date();
      const year   = hiduke.getFullYear();
      const month  = (hiduke.getMonth() + 1).toString().padStart(2, "0"); // ゼロ埋め
      const day    = hiduke.getDate().toString().padStart(2, "0"); // ゼロ埋め

      const todayDate = year + "-" + month + "-" + day;
      
      let res = null;
      
      if (arg1) {

        setTargetDate(arg1);
        res = await loadDayReport(arg1);
      } else {
        setTargetDate(todayDate);
        res = await loadDayReport(todayDate);
      }
      
      // const res = await loadDayReport(todayDate);

      setDayReport(res)

      // 就寝・起床情報を取得（指定された日付または今日の情報）
      const sleepTargetDate = arg1 || todayDate;
      const sleepRes = await dispatch(getSleepToday(sleepTargetDate));
      setSleepInfo(sleepRes);

    })();


  }, [])

  return (
    <div className="l-wrap l-wrap--home">

      <LoginFilter />
      <HeaderTitle />
      <MyAnalytics />

      <div className="l-home-main">
        <ul className="p-head-date">
          
          {/* 前の日付 */}
          
          {
            (dayReport && dayReport.prev_date) && (
              <li onClick={() => moveAnotherDate(dayReport.prev_date)} className="p-head-date-l"><i className="icon icon-arrow-l"></i></li>
            )
          }
          
          <li className="p-head-date-c">
            <span>{ dayReport && dayReport.report_date_y }</span>年
            <span>{ dayReport && dayReport.report_date_m }</span>月
            <span>{ dayReport && dayReport.report_date_d }</span>日
          </li>

           {/*次の日付 */}
          {
            (dayReport && dayReport.next_date) && (
              <li onClick={() => moveAnotherDate(dayReport.next_date)}  className="p-head-date-r"><i className="icon icon-arrow-r"></i></li>
            )
          }
          
        </ul>
        <div className="l-home-main__in">
          {/* 就寝・起床情報 */}
          <div style={{
            padding: '12px',
            margin: '30px 0 15px 0',
            backgroundColor: (sleepInfo && (!sleepInfo.yesterday_bedtime || !sleepInfo.today_wakeup_time)) ? '#fff3cd' : '#e8f5e9',
            borderRadius: '8px',
            border: (sleepInfo && (!sleepInfo.yesterday_bedtime || !sleepInfo.today_wakeup_time)) ? '1px solid #ffc107' : '1px solid #4caf50'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
              <span style={{ fontWeight: 'bold', color: '#333', fontSize: '14px' }}>睡眠記録</span>
              <button
                onClick={() => navigate('/sleep')}
                style={{
                  padding: '4px 12px',
                  backgroundColor: '#2196f3',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '11px'
                }}
              >
                カレンダー
              </button>
            </div>
            {isEditingSleep ? (
              /* 編集モード */
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '10px' }}>
                  <div style={{ textAlign: 'center', flex: 1 }}>
                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '4px' }}>
                      {(() => {
                        const today = new Date();
                        const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
                        if (sleepInfo?.today_date === todayStr) {
                          return '昨日の就寝';
                        } else if (sleepInfo?.yesterday_date) {
                          const parts = sleepInfo.yesterday_date.split('-');
                          return `前日(${parseInt(parts[1])}/${parseInt(parts[2])})の就寝`;
                        }
                        return '前日の就寝';
                      })()}
                    </div>
                    <input
                      type="time"
                      value={editBedtime}
                      onChange={(e) => setEditBedtime(e.target.value)}
                      style={{
                        padding: '6px',
                        fontSize: '14px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        width: '100px'
                      }}
                    />
                    {/* 00:00〜5:00の場合は翌日のAMであることを表示 */}
                    {(() => {
                      if (editBedtime) {
                        const [hours] = editBedtime.split(':').map(Number);
                        if (hours >= 0 && hours < 6) {
                          // sleepInfo.today_dateが当日なので、そのAMであることを表示
                          if (sleepInfo?.today_date) {
                            const parts = sleepInfo.today_date.split('-');
                            return (
                              <div style={{ fontSize: '10px', color: '#f57c00', marginTop: '4px' }}>
                                ※{parseInt(parts[1])}月{parseInt(parts[2])}日のAM
                              </div>
                            );
                          }
                        }
                      }
                      return null;
                    })()}
                  </div>
                  <div style={{ textAlign: 'center', flex: 1 }}>
                    <div style={{ fontSize: '11px', color: '#666', marginBottom: '4px' }}>
                      {(() => {
                        const today = new Date();
                        const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
                        if (sleepInfo?.today_date === todayStr) {
                          return '今日の起床';
                        } else if (sleepInfo?.today_date) {
                          const parts = sleepInfo.today_date.split('-');
                          return `${parseInt(parts[1])}/${parseInt(parts[2])}の起床`;
                        }
                        return '当日の起床';
                      })()}
                    </div>
                    <input
                      type="time"
                      value={editWakeupTime}
                      onChange={(e) => setEditWakeupTime(e.target.value)}
                      style={{
                        padding: '6px',
                        fontSize: '14px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        width: '100px'
                      }}
                    />
                  </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                  <button
                    onClick={cancelEditSleep}
                    disabled={savingSleep}
                    style={{
                      padding: '6px 16px',
                      backgroundColor: '#9e9e9e',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '12px'
                    }}
                  >
                    キャンセル
                  </button>
                  <button
                    onClick={handleSaveSleep}
                    disabled={savingSleep}
                    style={{
                      padding: '6px 16px',
                      backgroundColor: '#4caf50',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '12px'
                    }}
                  >
                    {savingSleep ? '保存中...' : '保存'}
                  </button>
                </div>
              </div>
            ) : (
              /* 表示モード */
              <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                <div style={{ textAlign: 'center', cursor: 'pointer' }} onClick={startEditSleep}>
                  <div style={{ fontSize: '11px', color: '#666' }}>
                    {(() => {
                      const today = new Date();
                      const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
                      if (sleepInfo?.today_date === todayStr) {
                        return '昨日の就寝';
                      } else if (sleepInfo?.yesterday_date) {
                        const parts = sleepInfo.yesterday_date.split('-');
                        return `前日(${parseInt(parts[1])}/${parseInt(parts[2])})の就寝`;
                      }
                      return '前日の就寝';
                    })()}
                  </div>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: sleepInfo?.yesterday_bedtime ? '#333' : '#f44336',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '4px'
                  }}>
                    {sleepInfo?.yesterday_bedtime || '未入力'}
                    <i className="icon icon-pen" style={{ fontSize: '12px', color: '#999' }}></i>
                  </div>
                </div>
                <div style={{ textAlign: 'center', cursor: 'pointer' }} onClick={startEditSleep}>
                  <div style={{ fontSize: '11px', color: '#666' }}>
                    {(() => {
                      const today = new Date();
                      const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
                      if (sleepInfo?.today_date === todayStr) {
                        return '今日の起床';
                      } else if (sleepInfo?.today_date) {
                        const parts = sleepInfo.today_date.split('-');
                        return `${parseInt(parts[1])}/${parseInt(parts[2])}の起床`;
                      }
                      return '当日の起床';
                    })()}
                  </div>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: sleepInfo?.today_wakeup_time ? '#333' : '#f44336',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '4px'
                  }}>
                    {sleepInfo?.today_wakeup_time || '未入力'}
                    <i className="icon icon-pen" style={{ fontSize: '12px', color: '#999' }}></i>
                  </div>
                </div>
              </div>
            )}
            {sleepInfo?.has_warnings && sleepInfo?.warnings?.length > 0 && (
              <div style={{
                marginTop: '8px',
                padding: '6px',
                backgroundColor: '#fff',
                borderRadius: '4px',
                textAlign: 'center',
                fontSize: '11px',
                color: '#f57c00'
              }}>
                {sleepInfo.warnings.map((warning, index) => (
                  <div key={index}>⚠️ {warning}</div>
                ))}
              </div>
            )}
          </div>

          <div className="p-hainyou">
            <dl className="p-hainyou-ml">
              <dt>排尿状況</dt>
              <dd><span className="__values">{ dayReport && dayReport.output_value }</span><span className="__ml">mL</span></dd>
            </dl>
            <ul className="p-hainyou-figures">
              <li>
                <ul className="__times">
                  <li><i className="icon icon-urine"></i><span className="u-fs-16">{ dayReport && dayReport.output_count }</span>回</li>
                  <li><i className="icon icon-moon"></i><span className="u-fs-16">{ dayReport && dayReport.asleep_output_percentage }</span>%</li>
                </ul>
              </li>
              <li><i className="icon icon-time"></i><span className="u-fs-16">{ dayReport && dayReport.last_time }</span></li>
            </ul>
          </div>
          <div className="u-pb-4">
            <p className="p-intake"><i className="icon icon-drink u-clr-light u-fs-16"></i><span
              className="u-clr-sky u-pe-1">水分摂取量</span><span className="u-fs-15">{ dayReport && dayReport.input_value }</span>mL</p>
          </div>
        </div>
      </div>


      <div className="l-oneday">


        <div className="l-oneday__bar">
          <ul className="p-time-list">
            <li>
              <div className="__items">
                <ul className="p-time-list-item">
                  <li></li>
                  <li><i className="icon icon-time u-clr-txt u-fs-16"></i></li>
                  <li><i className="icon icon-urine u-clr-urine u-fs-16"></i></li>
                  <li><i className="icon icon-drink u-clr-drink u-fs-16 __drink"></i></li>
                </ul>
              </div>
            </li>
          </ul>
        </div>


        <div className="l-oneday__block">

          <div className="l-oneday__list">
            <ul className="p-time-list">

              {
                (dayReport && dayReport.reports) &&

                    dayReport.reports.map(report => {
                       // report_datetimeから日付部分を取得して表示中の日付と比較
                       const reportDate = report.report_datetime ? report.report_datetime.split(' ')[0] : null;
                       const displayDate = dayReport.report_date;
                       const isDifferentDate = reportDate && reportDate !== displayDate;

                       // 異なる日付の場合は "(M/D)" 形式で表示
                       const dateSuffix = isDifferentDate ? (() => {
                         const parts = reportDate.split('-');
                         return `(${parseInt(parts[1])}/${parseInt(parts[2])})`;
                       })() : '';

                       return (
                    <li key={report.id}>
                    <Link to={"/manual/"+report.id}>
                    <ul className="p-time-list-item">
                    <li></li>
                    <li><span className="u-clr-sky">{report.is_night && <i className="icon icon-moon" style={{marginRight: '4px'}}></i>}{ report.time }{dateSuffix}</span></li>
                    <li><span className="u-clr-txt">{ report.report_type == "1" ? report.output_value + "mL" : "" }</span></li>
                    <li><span className="u-clr-txt">{ report.report_type == "2" ? report.input_value + "mL" : "" }</span></li>
                    </ul>
                    </Link>
                    </li>
                    )
                  }
                )
              }
              
            </ul>
          </div>
        </div>
      </div>
      
      
      
      
      
      <div className="l-foot-btn">
        <div className="l-foot-btn--in">
          <div className="u-txt-c u-mb-xxs">
            <button className="c-btn c-btn-solid c-btn-xl c-icon-btn" onClick={() => {navigate("/camera")}}><i
              className="icon icon-camera-line u-fs-18 u-pe-1"></i><span>排尿量撮影</span></button>
          </div>
          <div className="u-txt-c">

            <ul className="p-btn-record">

              <li>
                <button type={"button"} onClick={() => {navigate("/history")}} className="c-btn c-btn-line c-btn-xl c-icon-btn"><i
                  className="icon icon-calendar u-fs-18 u-pe-1"></i><span>過去記録</span></button>
              </li>

              <li>
                <button type={"button"} onClick={() => navigate("/manual") } className="c-btn c-btn-line c-btn-xl c-icon-btn"><i
                  className="icon icon-pen u-fs-18 u-pe-1"></i><span>記録</span></button>
              </li>

            </ul>

          </div>
        </div>
      </div>
      
      <PageTopButton />
    </div>
  )
}

export default TopPage;
